import React, { useState, useRef } from "react";
import {
  Show,
  TabbedShowLayout,
  Tab,
  ReferenceField,
  BooleanField,
  DeleteButton,
  TextField,
  DateField,
  NumberField,
  ReferenceManyField,
  Datagrid,
  DatagridBody,
  TopToolbar,
  RefreshButton,
  ListButton,
  EditButton,
  Button,
  Link,
  List,
  ShowController,
  SimpleShowLayout,
  ShowView,
  useRecordContext,
  usePermissions,
  useResourceContext,
  useGetOne,
  useRedirect,
  ShowButton,
} from "react-admin";
import {
  AmountField,
  LineItemTotalField,
  ExpectedDateField,
  CamelCaseField,
  ConvQtyField,
  ConvQtyUomField,
  PaymentAmountField,
} from "./common";
// import { LineItemsSideComponent } from '../singleDeliveryOrders/common';
import CreateSDOButton from "./createSdoButton";
import { getLocalStorageKey, getCurrencySymbol } from "../common/common";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import ThreeDotIcon from "@mui/icons-material/MoreVert";
// import AccessAlarmIcon from '@mui/icons-material/AccessAlarmIcon';
import CloseIcon from '@mui/icons-material/Close';
import CustomModal from "./CustomModal";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import moment from "moment";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import useWebSocket, { ReadyState } from "react-use-websocket";
import InfiniteScroll from "react-infinite-scroll-component";
import SimpleInfiniteScroller from "react-simple-infinite-scroller";


import { requestForToken, onMessageListener, messaging } from '../firebase';
import { getNotificationPermission } from '../Notification';
import { onMessage } from "firebase/messaging";
import { Howl } from 'howler';

let DeliveryNumber = 0;
let RecordId = [];
const apiUrl = RUN_TIME_API_ENDPOINT;
let orderStatus = null;
let isSdoCreated = 0;

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

// const CreateUser = ({ data, basePath, resource }) => {
//   console.log("record", data, basePath, resource);
//   return (
//     <Button
//       className="custom-button"
//       component={Link}
//       to={{
//         pathname: `/users/create`,
//         business_id: data && data.business_id,
//       }}
//     >
//       <span>Create User</span>
//     </Button>
//   );
// };

const ShowActions = (props) => {
  // const digitalOrderStatusKeyMappings = getLocalStorageKey('order_status_key_mappings');
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     openModal: false,
  //     openMessageModal: false,
  //     isResendBtnDisable: false,
  //     openPaymentModal: false,
  //     openPaymentMessageModal: false,
  //   };
  // }
  const record = useRecordContext();
  const location = useLocation();
  const redirect = useRedirect();

  const [openModal, setOpenModal] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [isResendBtnDisable, setIsResendBtnDisable] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openPaymentMessageModal, setOpenPaymentMessageModal] = useState(false);
  const [openOrderSendModal, setOpenOrderSendModal] = useState(false);
  const [openOrderSendMsgModal, setOpenOrderSendMsgModal] = useState(false);

  // open modal function
  const onOpenModal = () => {
    console.log("umesh ==>");
    // this.setState({ openModal: true });
    setOpenModal(true);
  };

  const onCloseModal = () => {
    // this.setState({ openModal: false });
    setOpenModal(false);
  };

  const onOkModal = (data) => {
    console.log("data 123 ===>", data);
    // this.setState({ openModal: false, openMessageModal: true });
    setOpenModal(false);
    setOpenMessageModal(true);

    // console.log(openMessageModal,data.order_number);
    const url = `${apiUrl}/sap_digital_orders/${data?.id}/resend_order`;
    const options = CommonHeaderOption();
    options.method = "PATCH";
    options.body = JSON.stringify({});

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json.data.resend_status);
        if (json.data.resend_status === "Re-sending") {
          // this.setState({ isResendBtnDisable: true });
          setIsResendBtnDisable(true);
          props.fromChildToParentCallback(true);
        }
      });
  };

  // open msg modal function
  const onCloseMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
  };

  const onOkMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
    setOpenOrderSendMsgModal(false);
    // openOrderSendMsgModal
  };

  const onOkSendOrderE1Modal = (data) => {
    setOpenModal(false);
    setOpenOrderSendModal(false);
    setOpenOrderSendMsgModal(true);
    // this.setState({
    //   openModal: false,
    //   openOrderSendModal: false,
    //   openOrderSendMsgModal: true,
    // });
    // console.log(this.state.openMessageModal,data.order_number);
    const url = `${apiUrl}sap_digital_orders/create_order`;
    const options = CommonHeaderOption();
    options.method = "POST";
    options.body = JSON.stringify({ order_number: data.order_number });

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        // console.log("json ===>", json.data.resend_status);
        // if (json.data.resend_status === "Re-sending") {
        //   this.setState({
        //     isResendBtnDisable: true,
        //     openOrderSendMsgModal: true,
        //   });
        //   this.props.fromChildToParentCallback(true);
        // }
      });
  };

  /**
   *
   * @returns Payment resend button
   */
  // open modal function
  const onPaymentOpenModal = () => {
    // this.setState({ openPaymentModal: true });
    setOpenPaymentModal(true);
  };

  const onPaymentCloseModal = () => {
    // this.setState({ openPaymentModal: false });\
    setOpenPaymentModal(false);
  };

  const onPaymentOkModal = (data) => {
    console.log("onPaymentOkModal data", data);
    const pathSplit = location.pathname.split("/");
    const orderID = pathSplit[2];
    // this.setState({ openPaymentModal: false, openPaymentMessageModal: true });
    setOpenPaymentModal(false);
    setOpenPaymentMessageModal(true);

    // console.log(openMessageModal,data.order_number);
    const url = `${apiUrl}/payment_status_confirm?order_id=${orderID}`;
    const options = CommonHeaderOption();
    options.method = "GET";
    // options.body = JSON.stringify({});

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json.data);
        // if (json.data.resend_status === "Re-sending") {
        //   this.setState({ isResendBtnDisable: true });
        //   props.fromChildToParentCallback(true);
        // }
      });
  };

  // open msg modal function
  const onPaymentCloseMessageModal = () => {
    // this.setState({ openPaymentMessageModal: false });
    setOpenPaymentMessageModal(false);
  };

  const onPaymentOkMessageModal = () => {
    // this.setState({ openPaymentMessageModal: false });
    setOpenPaymentMessageModal(false);
  };

  const { basePath, resource } = props;
  console.log("record....outside", record);
  const { data } = useGetOne("sap_digital_app_orders", { id: record?.id });

  const { permissions } = usePermissions();
  console.log(" permissions ====>", permissions);
  orderStatus = data && data.customer_order_status;
  isSdoCreated =
    data && data.sap_sdo_for_orders && data.sap_sdo_for_orders.length;
  return (
    <TopToolbar>
      {permissions !== "isManual" &&
        data &&
        data.digital_order_system === "isSapPH" &&
        data.customer_order_status != 0 && (
          <Button
            className="custom-button resend-button mr-send-btn"
            onClick={onPaymentOpenModal}
          //   disabled={
          //     !!isResendBtnDisable ||
          //     data.resend_status === "Re-sending"
          //   }
          >
            <span>Send payment info</span>
          </Button>
        )}
      {permissions !== "isManual" && data && !!openPaymentModal ? (
        <CustomModal
          open={openPaymentModal}
          onCloseModal={onPaymentCloseModal}
          showCancel={true}
          text="Are you sure you want to send the payment information to SAP?"
          onOkModal={(data) => onPaymentOkModal(data)}
        />
      ) : null}
      {permissions !== "isManual" && data && !!openPaymentMessageModal ? (
        <CustomModal
          open={openPaymentMessageModal}
          onCloseModal={onPaymentCloseMessageModal}
          showCancel={false}
          text="Data is successfully accepted"
          onOkModal={onPaymentOkMessageModal}
        />
      ) : null}

      {openOrderSendMsgModal ? (
        <CustomModal
          open={openOrderSendMsgModal}
          onCloseModal={onCloseMessageModal}
          showCancel={false}
          text="Your order is being sent to the system. You can check it's progress in the detail page."
          onOkModal={onOkMessageModal}
        />
      ) : null}

      {permissions !== "isManual" &&
        data &&
        (data.digital_order_system === "isSap" ||
          data.digital_order_system === "isSageAPI" ||
          data.digital_order_system === "isJDE" ||
          data.digital_order_system === "isSapPH" ||
          data.digital_order_system === "isMulesoft") &&
        (data.customer_order_status === "0" ||
          data.resend_status === "Re-send failed - Try again") && (
          <Button
            className="custom-button resend-button mr-send-btn"
            onClick={onOpenModal}
            disabled={
              !!isResendBtnDisable || data.resend_status === "Re-sending"
            }
          >
            <span>Re-send order</span>
          </Button>
        )}
      {permissions !== "isManual" && data && !!openModal ? (
        <CustomModal
          open={openModal}
          onCloseModal={onCloseModal}
          showCancel={true}
          text="Are you sure you want to re-send this order?"
          onOkModal={() => onOkModal(data)}
        />
      ) : null}
      {permissions !== "isManual" && data && !!openMessageModal ? (
        <CustomModal
          open={openMessageModal}
          onCloseModal={onCloseMessageModal}
          showCancel={false}
          text="Your order is being re-sent to the system. You can check it's progress in the detail page."
          onOkModal={onOkMessageModal}
        />
      ) : null}
      {/* <CreateUser data={data} basePath={basePath} resource={resource} /> */}
      <RefreshButton />
      <ListButton basePath={basePath} />
      {permissions === "isManual" && (
        <EditButton resource={basePath} record={data} />
      )}
      {/* )} */}
      {permissions !== "isManual" &&
        data &&
        (data.customer_order_status === "0" ||
          data.resend_status === "Re-send failed - Try again") && (
          <DeleteButton
            basePath={basePath}
            disabled={
              !!isResendBtnDisable || data.resend_status === "Re-sending"
            }
            record={data}
            resource={resource}
          />
        )}
    </TopToolbar>
  );
};

const SdoOrderMaterialsLink = () => {
  const record = useRecordContext();
  console.log("SdoOrderMaterialsLink record", record);
  if (
    record?.sap_materials_for_sdo &&
    record?.sap_materials_for_sdo.length > 0
  ) {
    return (
      <Button
        className="custom-button"
        component={Link}
        to={{
          pathname: "/sap_materials_for_sdos",
          search: `filter={"sap_sdo_for_order_id": ${record?.id}}`,
        }}
      >
        <span>Order Materials</span>
      </Button>
    );
  }
  return <span>No Order Materials</span>;
};

const SdoDisputeDetailsLink = () => {
  const record = useRecordContext();
  console.log("SdoDisputeDetailsLink record", record);
  if (record.sap_sdo_dispute && record.sap_sdo_dispute.length > 0) {
    return (
      <Button
        className="custom-button"
        component={Link}
        to={{
          pathname: "/sap_sdo_dispute/" + record.id + "/show",
          state: { record: { order_sdo_dispute: record } },
        }}
      >
        <span>Delivery Dispute</span>
      </Button>
    );
  }
  return <span>No Delivery Dispute</span>;
};

const DigitalOrderTitle = () => {
  const record = useRecordContext();
  return <span>{record ? `Order No. ${record.order_number} ` : ""}</span>;
};

const MyDatagridRow = ({ id, permissions }) => {
  const resource = useResourceContext();
  const record = useRecordContext();
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  console.log("props........record", record);

  if (RecordId.includes(record.id)) {
    DeliveryNumber += 1;
  } else {
    RecordId.push(record.id);
  }

  return (
    <TableRow key={record.id}>
      {/* {permissions === "isManual" && ( */}
      <TableCell>
        <EditButton record={record} basePath={resource} />
      </TableCell>
      {/* )} */}
      <TableCell>{DeliveryNumber}</TableCell>
      {/* <TableCell>
                {record.logon_order_no}
            </TableCell> */}
      {sdoFieldSettings &&
        sdoFieldSettings.shipment_number &&
        sdoFieldSettings.shipment_number.enabled && (
          <TableCell>{record.shipment_number}</TableCell>
        )}
      {sdoFieldSettings &&
        sdoFieldSettings.load_number &&
        sdoFieldSettings.load_number.enabled && (
          <TableCell>{record.load_number}</TableCell>
        )}
      {permissions === "isSap" && (
        <TableCell>{record.logon_order_no}</TableCell>
      )}
      <TableCell>{record.order_status_description}</TableCell>
      <TableCell>
        {record.loading_date &&
          moment(record.loading_date).format("DD/MM/YYYY, h:MM:SS A")}
      </TableCell>
      <TableCell>{record.truck_plate_no}</TableCell>
      <TableCell>{record.lsd_order_no}</TableCell>
      {permissions === "isSap" && <TableCell>{record.on_hold}</TableCell>}
      {permissions === "isSap" && (
        <TableCell>{record.order_validation_code}</TableCell>
      )}
      {permissions === "isSap" && <TableCell>{record.pod_code}</TableCell>}
      <TableCell>
        {(record.receive_full_order === true && "YES") ||
          (record.receive_full_order === false && "NO")}
      </TableCell>
      <TableCell>
        {record.received_date &&
          moment(record.received_date).format("DD/MM/YYYY, h:MM:SS A")}
      </TableCell>
      <TableCell>
        {record.sap_sdo_dispute &&
          record.sap_sdo_dispute.length > 0 &&
          moment(record.sap_sdo_dispute[0].created_at).format(
            "DD/MM/YYYY, h:MM:SS A"
          )}
      </TableCell>
      <TableCell>
        <SdoOrderMaterialsLink />
      </TableCell>
      <TableCell>
        <SdoDisputeDetailsLink record={record} />
      </TableCell>
    </TableRow>
  );
};

const MyDatagridBody = (props) => {
  console.log("props........", props);
  return (
    <DatagridBody
      {...props}
      row={<MyDatagridRow permissions={props.permissions} />}
    />
  );
};

const MyDatagrid = (props) => {
  DeliveryNumber = 0;
  console.log("props../././.", props);
  return (
    <Datagrid
      {...props}
      body={<MyDatagridBody permissions={props.permissions} />}
    />
  );
};

const PayerField = () => {
  const record = useRecordContext();
  return (
    <div>
      <div className="show-page-label">Payer</div>
      <div className="show-page-value">
        {record.payerDetails && record.payerDetails.payer_name}(
        {record.payerDetails && record.payerDetails.payer_sap_code})
      </div>
    </div>
  );
};

const CustomerOrderStatusField = ({ isChildResendBtnDisable }) => {
  const record = useRecordContext();
  console.log("_______", isChildResendBtnDisable, record);
  if (
    record.resend_status !== null &&
    !isChildResendBtnDisable &&
    record.resend_status === "Re-send failed - Try again"
  ) {
    return (
      <div>
        <div className="show-page-label">Order Status</div>
        <div className="show-page-value">{record.resend_status}</div>
      </div>
    );
  } else if (!!isChildResendBtnDisable) {
    return (
      <div>
        <div className="show-page-label">Order Status</div>
        <div className="show-page-value">Re-sending</div>
      </div>
    );
  } else {
    return (
      <div>
        <div className="show-page-label">Order Status</div>
        <div className="show-page-value">
          {record.customer_order_status_desc}
        </div>
      </div>
    );
  }
};

const DigitalOrdersShow = (props) => {
  const record = useRecordContext();
  const location = useLocation();
  const pathSplit = location.pathname.split('/');
  const businessIdVal = pathSplit[2];
  console.log("recorddddddddd", location, businessIdVal);
  const localStorageLocale = getLocalStorageKey("locale");
  const countryCodeArray = localStorageLocale.split("-");
  const countryCode = countryCodeArray[1];



  const [isChildResendBtnDisable, setIsChildResendBtnDisable] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);

  /* -----chat app-------- */
  const chatEndpoints = getLocalStorageKey('chat_endpoints');
  const isChatEnabled = getLocalStorageKey('is_chat_enabled');
  console.log('chat_endpoints', chatEndpoints);
  const id = getLocalStorageKey("id");
  let token = getLocalStorageKey("_token");
  const opcoDetails = getLocalStorageKey("opco");
  const opco_country_id = opcoDetails && opcoDetails.country_id;
  const userName = getLocalStorageKey("username");
  const [data, setData] = React.useState({});
  // const { data } = useGetOne("sap_digital_app_orders", { id: businessIdVal });


  React.useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    // (businessIdVal != null || businessIdVal != undefined) &&
    if (isChatEnabled) {
      fetch(`${apiUrl}/sap_digital_app_orders/${businessIdVal}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          setData(jsonD.data);
          console.log('response here data', jsonD.data);
          const resData = jsonD.data
          if (ReadyState.OPEN && Object.keys(resData).length) {
            joinRoom(resData);
          }
          console.log("obj==>", jsonD);
        });
    }
  }, [isChatEnabled]);

  const [messageList, setMessageList] = React.useState([]);
  const [message, setMessage] = React.useState("");
  const [lastRoomId, setLastRoomId] = useState("");
  const [lastMessageId, setLastMessageId] = React.useState("");
  const [lastCreatedAt, setLastCreatedAt] = React.useState("");
  const [currentRoomId, setCurrentRoomId] = React.useState('')
  const [isLastEvaluatedKeyPresent, setIsLastEvaluatedKeyPresent] =
    React.useState(true);
  const [participantList, setParticipantList] = React.useState([]);
  const socketUrl = chatEndpoints?.create_webhook;
  // "wss://1nowgxoecg.execute-api.eu-west-1.amazonaws.com/staging";
  const {
    sendJsonMessage,
    sendMessage,
    getWebSocket,
    lastJsonMessage,
    readyState,
    lastMessage,
  } = useWebSocket(socketUrl, {
    onOpen: () => console.log("WebSocket connection opened."),
    onClose: () => console.log("WebSocket connection closed."),
    shouldReconnect: (closeEvent) => true,
    reconnectAttempts: 5,
    // onMessage: (event) =>  processMessages(event)
  });
  const [isLoader, setIsLoader] = React.useState(true);
  const [showReadModal, setShowReadModal] = React.useState(false);
  const [currentMsgInfo, setCurrentMsgInfo] = React.useState({});
  const [readParticipants, setReadParticipants] = React.useState([]);
  const [unreadParticipants, setUnreadParticipants] = React.useState([]);
  const [unreadMsgCount, setUnreadMsgCount] = React.useState(0);
  const [readUnReadTabValue, setReadUnReadTabValue] = React.useState(1);
  // const messageIdSet = new Set(); // To track unique message IDs
  const messageIdSet = useRef(new Set());
  const scrollableRef = useRef(null);


  const connectionStatus = {
    [ReadyState.CONNECTING]: "Connecting",
    [ReadyState.OPEN]: "Open",
    [ReadyState.CLOSING]: "Closing",
    [ReadyState.CLOSED]: "Closed",
    [ReadyState.UNINSTANTIATED]: "Uninstantiated",
  }[readyState];

  // React.useEffect(() => {
  //   if (lastMessage !== null) {
  //     console.log("lastMessage is ", lastMessage);
  //   }
  // }, [lastMessage]);

  // React.useEffect(() => {
  //   if (lastJsonMessage !== null) {
  //     console.log("lastJsonMessage is ", lastJsonMessage);
  //     if (lastJsonMessage.message == "Connection Successfull") {
  //       joinRoom();
  //     }
  //   }
  // }, [lastJsonMessage]);

  // React.useEffect(() => {
  //   if (ReadyState.OPEN) {
  //     joinRoom();
  //   }
  // }, []);


  React.useEffect(() => {
    console.log("lastJsonMessage==", lastJsonMessage, lastJsonMessage?.messageData);
    if (isChatEnabled) {
      if (lastJsonMessage?.messageData != undefined || lastJsonMessage?.messageData != null) {
        const messageData = lastJsonMessage?.messageData;
        const newMessage = {
          _id: messageList?.length + 1,
          text: messageData?.message,
          createdAt: messageData?.created_at,
          user: {
            _id: parseInt(messageData?.user_id),
            name: messageData?.user_name,
          },
          message_id: messageData?.message_id,
          user_id: messageData?.user_id,
          user_type: messageData?.user_type,
          country_id: messageData?.country_id,
          region: messageData?.region,
          message_created_from: messageData?.message_created_from,
          client_side_timestamp: messageData?.client_side_timestamp,
          business_id: `${data?.business_id}`,
          sap_digital_order_id: businessIdVal,
        };
        if (lastJsonMessage?.messageData?.room_id == currentRoomId) {
          msgReadApiCall(messageData, data);
          setMessageList((prevState) => [newMessage, ...prevState]);
        }
        console.log("---------------------------------2");
      }
    }
  }, [lastJsonMessage, isChatEnabled]);

  // const msgReadApiCall = (message_id) => {
  //   const postData = {
  //     action: "mark_message_as_read",
  //     user_id: `${id}`,
  //     user_type: "admin",
  //     country_id: `${opco_country_id}`,
  //     order_number: `${data?.order_number}`,
  //     region: "mea",
  //     message_id: `${message_id}`,
  //     message_read_at: `${new Date().toISOString()}`,
  //     access_token: `${token}`,
  //   };
  //   console.log("msgReadApiCall===", postData);
  //   sendJsonMessage(postData);
  // };

  const msgReadApiCall = React.useCallback(
    (firstElement, data) => {
      const postData = {
        action: "mark_message_as_read",
        user_id: `${id}`,
        user_type: "admin",
        country_id: `${opco_country_id}`,
        order_number: `${data?.order_number}`,
        region: "mea",
        message_id: `${firstElement?.message_id}`,
        message_read_at: `${new Date().toISOString()}`,
        access_token: `${token}`,
        created_at: `${firstElement?.createdAt}`
      };

      console.log("msgReadApiCall===", data, postData);
      sendJsonMessage(postData);
    }
    ,
    [],
  );

  React.useEffect(() => {
    if (ReadyState.OPEN) {
      console.log("websocket is ", connectionStatus);
      connectUser();
    }
  }, [readyState, data]);

  const connectUser = React.useCallback(() => {
    console.log("connnect userrrrrrrrrrrrrrrrrrrrrrrrrr", localStorageLocale);
    sendJsonMessage({
      action: "newConnection",
      user_id: `${id}`,
      user_type: `admin`,
      access_token: `${token}`,
      country_id: `${opco_country_id}`,
      region: "mea",
    });
  }, [data]);

  const handleClickSendMessage = React.useCallback((msg) => {
    sendJsonMessage({
      action: "newMessage",
      user_id: `${id}`,
      user_type: `admin`,
      user_name: `${userName}`,
      access_token: `${token}`,
      order_number: `${data?.order_number}`,
      message: `${msg}`,
      country_id: `${opco_country_id}`,
      region: "mea",
      message_created_from: "admin-web-app",
      client_side_timestamp: `${new Date().toISOString()}`,
      business_id: `${data?.business_id}`,
      sap_digital_order_id: businessIdVal,
    })
  }, [data]);

  const joinRoom = React.useCallback((data) => {
    const postData = {
      user_id: `${id}`,
      user_type: `admin`,
      business_id: `${data?.business_id}`,
      order_info: {
        order_number: `${data?.order_number}`,
        sold_to_code: `${data?.business_site?.sold_to_code}`,
        solt_to_name: "test",
        order_status: `${data?.customer_order_status}`,
        order_status_desc: `${data?.customer_order_status_desc}`,
        ship_to_code: `${data?.business_site?.ship_to_sap_number}`,
        ship_to_name: `${data?.business_site?.name}`,
      },
      country_id: `${opco_country_id}`,
      region: "mea",
    };

    const options = CommonHeaderOption();
    options.method = "POST";
    options.body = JSON.stringify(postData);
    if (isChatEnabled) {
      fetch(
        chatEndpoints?.create_join_room,
        // `https://j4ooul8g4a.execute-api.eu-west-1.amazonaws.com/default/clickit_chat_staging_create_or_join_room`,
        options
      )
        .then((res) => {
          if (res.ok) return res.json();
          return res.json().then((res) => {
            throw new Error(res.message);
          });
        })
        .then((json) => {
          if (json) {
            console.log("joinRoom json reply", json, data);
            // if (json.message == "Room already exists" || json.message == "Room updated successfully") {
            if (json.success) {
              fetchMsgList(null, data);
              fetchUnreadMsgCount(data)
            }
            setCurrentRoomId(json?.chatRoom?.room_id)
            if (json.chatRoom.participant_list) {
              const nonNullList = json.chatRoom.participant_list.filter(participant => participant.name != null);
              setParticipantList(nonNullList);
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }, [isChatEnabled]);

  const formattedMessages = (reverseData, data) => {
    let formattingArray = reverseData.map((msg, index) => ({
      _id: index + 1,
      text: msg.message,
      createdAt: msg.created_at,
      user: {
        _id: parseInt(msg.user_id),
        name: msg.user_name,
      },
      message_id: msg.message_id,
      user_id: msg.user_id,
      user_type: msg.user_type,
      country_id: msg.country_id,
      message_created_from: msg?.message_created_from,
    }));

    let array = formattingArray.sort((a, b) => {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
    console.log("the data here", data, array);
    setMessageList(array);
    console.log("---------------------------------3");
    setIsLoader(false);
    msgReadApiCall(array[0], data);
  };

  // const mergeAndSortMessages = (newMessages) => {
  //   setMessageList((prevMessageList) => {
  //     // Filter out messages with duplicate IDs
  //     const filteredNewMessages = newMessages.filter((message) => !messageIdSet.has(message.message_id));

  //     // Add new message IDs to the Set
  //     filteredNewMessages.forEach((message) => messageIdSet.add(message.message_id));

  //     // Merge the previous messages with the filtered new messages
  //     const temp = [...prevMessageList, ...filteredNewMessages];

  //     // Sort the merged array by createdAt in descending order
  //     const sortedArray = temp.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  //     return sortedArray;
  //   });
  // };

  const mergeAndSortMessages = (newMessages) => {
    setMessageList((prevMessageList) => {
      // Filter out messages with duplicate IDs
      const filteredNewMessages = newMessages.filter((message) => !messageIdSet.current.has(message.message_id));

      // Add new message IDs to the Set
      filteredNewMessages.forEach((message) => messageIdSet.current.add(message.message_id));

      // Merge the previous messages with the filtered new messages
      const temp = [...prevMessageList, ...filteredNewMessages];

      // Sort the merged array by createdAt in descending order
      const sortedArray = temp.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      return sortedArray;
    });
  };


  const fetchMsgList =
    React.useCallback(
      (pagination, data) => {
        console.log('fetchMsgList', pagination, data);
        const orderNumber = data?.order_number;
        const userId = id.toString();
        const userType = `admin`;
        // const apiUrl = `https://j4ooul8g4a.execute-api.eu-west-1.amazonaws.com/default/clickit_chat_staging_get_messages_by_orderid_with_pagination?order_number=${orderNumber}&user_id=${userId}&user_type=admin&region=mea&country_id=${opco_country_id}`;
        const apiUrl = `${chatEndpoints?.get_message_list}?order_number=${orderNumber}&user_id=${userId}&user_type=admin&region=mea&country_id=${opco_country_id}`
        const apiUrlWithPagination =
          !!pagination
            ? `${apiUrl}&last_room_id=${lastRoomId}&last_message_id=${lastMessageId}&last_message_created_at=${lastCreatedAt}`
            : `${apiUrl}`;

        console.log('fien', `${lastRoomId} ..${lastMessageId} ...${lastCreatedAt}`);

        const options = CommonHeaderOption();
        options.method = "GET";
        // options.body = JSON.stringify(postData);
        if (isChatEnabled) {
          fetch(apiUrlWithPagination, options)
            .then((res) => {
              if (res.ok) return res.json();
              return res.json().then((res) => {
                throw new Error(res.message);
              });
            })
            //     .then((json) => {
            //     if (json) {
            //         console.log("fetchMsgList", json);
            //         setMessageList(json.messages)
            //     }
            //     }).catch(error => {
            //         console.log('error',error);
            // });
            .then((response) => {
              console.log("respomse heree", response);
              if (response?.LastEvaluatedKey) {
                setLastMessageId(response?.LastEvaluatedKey?.message_id);
                setLastRoomId(response?.LastEvaluatedKey?.room_id);
                setLastCreatedAt(response?.LastEvaluatedKey?.created_at);
                setIsLastEvaluatedKeyPresent(true);
              } else {
                setLastMessageId("");
                setLastRoomId("");
                setLastCreatedAt("");
                setIsLastEvaluatedKeyPresent(false);
              }
              // const aiseHiMsg = response.messages.map((msg, index) => ({
              //   _id: messageList.length + index + 1,
              //   text: msg.message,
              //   createdAt: msg.created_at,
              //   user: {
              //     _id: parseInt(msg.user_id),
              //     name: msg.user_name,
              //   },
              //   message_id: msg?.message_id,
              //   user_id: msg?.user_id,
              //   user_type: msg?.user_type,
              //   country_id: msg?.country_id,
              //   region: msg?.region,
              //   message_created_from: msg?.message_created_from,
              //   client_side_timestamp: msg?.client_side_timestamp,
              //   business_id: msg?.business_id,
              // }));
              // mergeAndSortMessagesA(aiseHiMsg);

              console.log("response.data response.data", !pagination);
              if (!pagination) {
                console.log("response.data in !", response, !pagination);
                formattedMessages(response.messages.reverse(), data);
              } else {
                console.log("response.data in ZzZ", response, !pagination);
                const earlierMessages = response.messages.map((msg, index) => ({
                  _id: messageList.length + index + 1,
                  text: msg.message,
                  createdAt: msg.created_at,
                  user: {
                    _id: parseInt(msg.user_id),
                    name: msg.user_name,
                  },
                  message_id: msg?.message_id,
                  user_id: msg?.user_id,
                  user_type: msg?.user_type,
                  country_id: msg?.country_id,
                  region: msg?.region,
                  message_created_from: msg?.message_created_from,
                  client_side_timestamp: msg?.client_side_timestamp,
                  business_id: msg?.business_id,
                }));

                // let temp = [...messageList, ...earlierMessages];
                // let array = temp.sort((a, b) => {
                //   return (
                //     new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
                //   );
                // });
                // setMessageList(array);

                mergeAndSortMessages(earlierMessages);
                console.log("---------------------------------5");
              }
            })
            .catch((err) => {
              setIsLoader(false);
              console.log("err==", err);
            });
        }

        // if (scrollableRef.current) {
        //   const { scrollHeight, clientHeight } = scrollableRef.current;
        //   scrollableRef.current.scrollTop = scrollHeight - clientHeight;
        // }
      }
      ,
      [data, lastRoomId, lastMessageId, lastCreatedAt, isChatEnabled],
    );

  const fetchUnreadMsgCount = (data) => {
    const orderNumber = data?.order_number;
    const userId = id.toString();
    const userType = `admin`;
    // const apiUrl = `https://j4ooul8g4a.execute-api.eu-west-1.amazonaws.com/default/clickit_chat_staging_get_unread_messages_count_of_user_of_room?region=mea&country_id=${opco_country_id}&order_number=${orderNumber}&user_id=${userId}&user_type=${userType}`;
    const apiUrl = `${chatEndpoints?.get_unread_count}?region=mea&country_id=${opco_country_id}&order_number=${orderNumber}&user_id=${userId}&user_type=${userType}`;

    const options = CommonHeaderOption();
    options.method = "GET";
    // options.body = JSON.stringify(postData);
    if (isChatEnabled) {
      fetch(apiUrl, options)
        .then((res) => {
          if (res.ok) return res.json();
          return res.json().then((res) => {
            throw new Error(res.message);
          });
        })
        .then((response) => {
          console.log("uread msg heree", response);
          setUnreadMsgCount(response?.totalUnreadMessages)
        })
        .catch((err) => {
          console.log("err==", err);
        });
    }
  }



  const changeMessage = (event) => {
    event.preventDefault();
    let positionObject = event.target.value;
    // if (
    //   event.target.value === "" ||
    //   event.target.value === undefined ||
    //   event.target.value === null ||
    //   !event.target.value.trim().length
    // ) {
    //   setMessageError(true);
    // } else {
    //   setMessageError(false);
    // }
    setMessage(positionObject);
  };

  const sendNewMessage = (e) => {
    console.log(message);
    e.preventDefault();
    handleClickSendMessage(message);
    const msg = {
      action: "newMessage",
      user_id: `${id}`,
      user_type: `admin`,
      user_name: `${userName}`,
      access_token: `${token}`,
      order_number: `${data?.order_number}`,
      message: `${message}`,
      country_id: `${opco_country_id}`,
      region: "mea",
      message_created_from: "admin-web-app",
      client_side_timestamp: `${new Date().toISOString()}`,
      business_id: `${data?.business_id}`,
      sap_digital_order_id: businessIdVal,
    };

    const newMessage = {
      _id: messageList.length + 1,
      text: message,
      createdAt: moment().toString(),
      user: {
        _id: id,
        name: userName,
      },
      country_id: opco_country_id,
      message_created_from: "admin-web-app",
      user_id: id,
      user_type: "admin"
    };
    // setMessageList((prevState) => [newMessage, ...prevState]);
    setMessage("");
  };

  const styles = {
    orange: {
      backgroundColor: "orange",
    },
    green: {
      backgroundColor: "green",
    },
    red: {
      backgroundColor: "red",
    },
    gray: {
      backgroundColor: "gray",
    },
  };

  const currentStyle = (() => {
    switch (readyState) {
      case 0:
        return styles.orange;
      case 1:
        return styles.green;
      case 2:
        return styles.red;
      case 3:
        return styles.red;
      case -1:
        return styles.gray;
      default:
        return styles.gray;
    }
  })();

  const currentChatStatus = (() => {
    switch (readyState) {
      case 0:
        return `CONNECTING`;
      case 1:
        return `OPEN`;
      case 2:
        return `CLOSING`;
      case 3:
        return `CLOSED`;
      case -1:
        return `UNINSTANTIATED`;
      default:
        return `...`;
    }
  })();

  const chatLabel = `Chat (${unreadMsgCount})`


  const getInitials = (name) => {
    const nameParts = name.split(' ');
    const firstInitial = nameParts[0] ? nameParts[0].charAt(0).toUpperCase() : '';
    const lastInitial = nameParts[1] ? nameParts[1].charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  };



  /* ------chat app------- */

  /*------------------------*/
  const navigate = useNavigate();
  const [isPermissionModalOpen, setIsPermissionModalOpen] = React.useState(true);
  const [isUserInteracted, setIsUserInteracted] = React.useState(false);
  const audio = new Audio('/public/notification.mp3');

  const [notification, setNotification] = React.useState({ title: '', body: '' });
  const notify = () => (
    Swal.fire({
      html: `Title: ${notification.title}  Body: ${notification.body}`,
      icon: "success",
    })
  );

  const redirectToSap = (data) => {
    window.open(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`, "_blank");
    navigate(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`);
  };

  React.useEffect(() => {
    // const handleUserInteraction = () => {
    //   setIsUserInteracted(true);
    //   document.removeEventListener('click', handleUserInteraction);
    //   document.removeEventListener('keydown', handleUserInteraction);
    // };

    // document.addEventListener('click', handleUserInteraction);
    // document.addEventListener('keydown', handleUserInteraction);

    // const handleForegroundMessage = () => {
    //   console.log('Message received. ');
    //   if (isUserInteracted) {
    //     audio.play().catch((err) => console.log('Failed to play sound:', err));
    //   }
    // };

    onMessage(messaging, (payload) => {
      console.log("foreground payload", payload);
      // handleForegroundMessage();
      var sound = new Howl({
        src: ['/notification.mp3']
      });

      sound.play();
      setNotification({ title: payload?.notification?.title, body: payload?.notification?.body });
      const notificationTitle = payload.notification.title;
      const notificationBody = payload.notification.body;
      const notificationOptions = {
        body: payload.notification.body,
        sound: 'default',
        icon: 'https://homepages.cae.wisc.edu/~ece533/images/zelda.png'

      };
      const notification = new Notification(notificationTitle, {
        body: notificationBody,
        icon: './images/navender_logo.png', // Path to the icon image
        data: { url: 'https://developer.mozilla.org/' } // Custom data, if needed
      });

      notification.onclick = (event) => {
        const redirectUrl = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ? `http://localhost:3000/sap_digital_app_orders/${payload?.data?.sap_digital_order_id}/show/3` : `${process.env.API_URL}/sap_digital_app_orders/${payload?.data?.sap_digital_order_id}/show/3`;
        // event.preventDefault(); // prevent the browser from focusing the Notification's tab
        window.open(redirectUrl, "_blank");
      };

      // notification.addEventListener("click", (data) => {
      //   console.log("User opened the notification");
      //   window.open(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`, "_blank");
      //   notification.close(); // close notification when user clicks on it
      // });
      // notification.onclick = (event,data) => {
      //   event.preventDefault();
      //   console.log('clicked on notification');
      //     // redirectToSap(payload.data);
      //     window.open(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`, "_blank");
      //     notification.close();
      //     window.parent.focus();
      // };
      // return () => {
      //   document.removeEventListener('click', handleUserInteraction);
      //   document.removeEventListener('keydown', handleUserInteraction);
      // };
    });
  }, []);

  // React.useEffect(() => {
  //   if (navigator.serviceWorker) {
  //     navigator.serviceWorker.addEventListener('message', (event) => {
  //       if (event.data === 'playSound' && isUserInteracted) {
  //         audio.play().catch((err) => console.log('Failed to play sound::::::::', err));
  //       }
  //     });
  //   }
  // }, [isUserInteracted]);

  React.useEffect(() => {
    if (Notification.permission === 'granted') {
      getNotificationPermission(id).then(() => {
        console.log('hi i a here in this app js')
        setIsPermissionModalOpen(false);
      })
    }
  }, [])

  React.useEffect(() => {
    if (notification?.title) {
      notify()
    }
  }, [notification])

  async function notificationPermission() {
    console.log('hi i a here in this app js')
    await getNotificationPermission(id).then(() => {
      setIsPermissionModalOpen(false);
    })
  }

  function displayPermissionModal() {
    console.log('wasssssssssssssssssupppppppp');
    return (
      <Modal open={isPermissionModalOpen} onClose={() => setIsPermissionModalOpen(!isPermissionModalOpen)} center>
        <h3>{'modalMsg'}</h3>
        <button onClick={notificationPermission}>click me</button>
      </Modal>
    )
  }

  /*------------------------*/

  const receiveChildValue = (value) => {
    console.log("Parent received value from child: " + value);
    // this.setState({ isChildResendBtnDisable: JSON.parse(value) });
    setIsChildResendBtnDisable(JSON.parse(value));
  };

  const onCloseMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
  };

  const onOkMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
  };

  const showModalForEdit = () => {
    // this.setState({ openMessageModal: true });
    setOpenMessageModal(true);
  };

  const { permissions } = usePermissions();
  const resource = useResourceContext();
  // const record = useRecordContext();
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const showLineItemEdit = getLocalStorageKey("show_line_item_edit");
  console.log("sdoFieldSettings", sdoFieldSettings);

  const TruckPlateField = ({ source }) => {
    const record = useRecordContext();
    return (
      <span>
        {record[source] === "-" ? "-" : record[source] ? record[source] : "-"}
      </span>
    );
  };

  const EditBtnField = () => {
    const record = useRecordContext();
    const resource = useResourceContext();
    console.log("XXXXXXXXXXX", record, resource);
    return (
      <EditButton
        resource={resource}
        to={{
          pathname: `/sap_sdo_for_orders/${record.id}`,
          state: {
            order: record,
          },
        }}
        label="Edit"
      />
    );
  };


  const LsdOrderNoField = ({ source }) => {
    const record = useRecordContext();
    return (
      <span>
        {record[source] === "-" ? "-" : record[source] ? record[source] : "-"}
      </span>
    );
  };

  const ReceiveFullOrderField = ({ source }) => {
    const record = useRecordContext();
    return (
      <span>
        {record[source] === "-" ? "-" : record[source] ? record[source] : "-"}
      </span>
    );
  };

  const LoadingDateField = ({ source }) => {
    const record = useRecordContext();
    if (record[source] === null) {
      return <span>{"-"}</span>;
    }

    return <DateField record={record} source={source} />;
  };

  const ReceivedDateField = ({ source }) => {
    const record = useRecordContext();
    if (record[source] === null) {
      return <span>{"-"}</span>;
    }

    return <DateField record={record} source={source} />;
  };

  const openReadInfo = (msg) => {
    console.log("--000-----", msg);
    setCurrentMsgInfo(msg);
    setShowReadModal(true);
    getUnReadMsgInfo(msg);
  };

  const getUnReadMsgInfo = (msg) => {
    const orderNumber = data?.order_number;
    const message_id = msg?.message_id;
    const country_id = msg?.country_id;
    const region = "mea";
    // const apiUrl = `https://j4ooul8g4a.execute-api.eu-west-1.amazonaws.com/default/clickit_chat_staging_get_read_unread_participants_of_a_message?order_number=${orderNumber}&message_id=${message_id}&country_id=${country_id}&region=${region}`;
    const apiUrl = `${chatEndpoints?.get_read_unread_participent}?order_number=${orderNumber}&message_id=${message_id}&country_id=${country_id}&region=${region}`

    const options = CommonHeaderOption();
    options.method = "GET";
    // options.body = JSON.stringify(postData);
    if (isChatEnabled) {
      fetch(apiUrl, options)
        .then((res) => {
          if (res.ok) return res.json();
          return res.json().then((res) => {
            throw new Error(res.message);
          });
        })
        .then((response) => {
          console.log("respomse heree", response);
          const nonNullReadList = response.readParticipants.filter(participant => participant.name != null);
          const nonNullUnREadList = response.unreadParticipants.filter(participant => participant.name != null);
          setReadParticipants(nonNullReadList);
          setUnreadParticipants(nonNullUnREadList);
        })
        .catch((err) => {
          console.log("err==", err);
        });
    }
  };

  const loadMoreFetchMsgList = () => {
    // doSomething();
    // if ((Object.keys(data).length > 0) ) {
    fetchMsgList(true, data)
    // Maintain scroll position
    // if (scrollableRef.current) {
    //   const { scrollHeight, clientHeight } = scrollableRef.current;
    //   scrollableRef.current.scrollTop = scrollHeight - clientHeight;
    // }
    // }
    console.log('hi saheban', data)
  }

  const toggleReadUnReadFunction = (val) => {
    console.log('val', val);
    setReadUnReadTabValue(val)

  }


  return (
    <div>
      {
        (isPermissionModalOpen && !(Notification.permission === 'granted')) &&
        <Modal
          open={isPermissionModalOpen}
          onClose={() => setIsPermissionModalOpen(false)}
          center
        >
          <div className="an-txt">
            Please click on Allow when the browser asks you to provide
            access to notifications so that you can receive chat
            notifications.
          </div>
          <button className="an-btn" onClick={notificationPermission}>
            OK
          </button>
        </Modal>
      }
      <Show
        title={<DigitalOrderTitle />}
        actions={
          <ShowActions
            fromChildToParentCallback={receiveChildValue}
            permissions={permissions}
          />
        }
        {...props}
      >
        <TabbedShowLayout className="tab-scroll">
          <Tab label="Order Details" contentClassName="scrollTab">
            {/* <ShowController {...props}>
                {(controllerProps) => (
                  <>
                    <TextField source="mode_of_transport" />
                    <TextField source="vehicle_type" label="Truck Type" />
                  </>
                )}
              </ShowController> */}
            <ShowController {...props}>
              {(controllerProps) => {
                const Mod = controllerProps.record.mode_of_delivery;
                console.log("ModModModModMod", Mod);
                const orderPendingNote =
                  controllerProps.record.sap_order_failed_message;
                return (
                  <ShowView
                    {...props}
                    actions={<></>}
                    {...controllerProps}
                    title=" "
                  >
                    <SimpleShowLayout className="simpleLayoutCustom">
                      <TextField source="order_number" />
                      {/* <TextField label="Order Status" source="customer_order_status_desc" /> */}
                      <CustomerOrderStatusField
                        isChildResendBtnDisable={isChildResendBtnDisable}
                      />
                      <ReferenceField
                        // label="Sold To Name"
                        source="business_id"
                        reference="businesses"
                        link="show"
                        allowEmpty
                      >
                        <TextField source="name" />
                      </ReferenceField>
                      <TextField
                        // label="Ship To Name"
                        source="business_site.name"
                      />
                      {/* <ReferenceField
                          label="Ship To Name"
                          source="sap_business_site_id"
                          reference="sap_business_sites"
                          link="show"
                          allowEmpty
                        >
                          <TextField source="name" />
                        </ReferenceField> */}
                      {permissions === "isSap" && <PayerField />}
                      {/* <ReferenceField label="Contract Number" source="sap_contract_id" reference="sap_contracts" linkType="show" allowEmpty>
                            <TextField  source="contarctDetails.contract_number" />
                        </ReferenceField> */}
                      <TextField
                        label="Contract Number"
                        source="contarctDetails.contract_number"
                      />
                      <CamelCaseField
                        source="mode_of_delivery"
                        // label="Mode of Delivery"
                        addLabel
                      />
                      <ReferenceField
                        // label="User name"
                        source="place_order_user_id"
                        reference="users"
                        link="show"
                        allowEmpty
                      >
                        <TextField source="first_name" />
                      </ReferenceField>
                      {/* <ExpectedDateField
                label="Expected Date"
                source="delivery_date_from"
                addLabel
              /> */}
                      <DateField
                        // label="Requested Delivery Date"
                        source="delivery_date_from"
                      />

                      <TextField
                        // label="Local PO Note"
                        source="customer_ref_number"
                      />
                      {Mod === "self_collect" && (
                        <TextField source="sap_plant.name" label="Plant Name" />
                      )}
                      {Mod === "self_collect" && (
                        <TextField
                          source="truck_number"
                        // label="Truck Number"
                        />
                      )}
                      {Mod === "self_collect" && (
                        <TextField
                          source="driver_details"
                        // label="Driver Details"
                        />
                      )}
                      <TextField source="is_app_order" sortable={false} />
                      {Mod === "delivered" && (
                        <TextField
                          source="delivery_address"
                        // label="Delivery Address"
                        />
                      )}
                      <TextField source="payment_method" />
                      <PaymentAmountField source="payment_amount" addLabel />
                      <TextField source="payment_status" />
                      {orderPendingNote && (
                        <TextField
                          // label="Order Pending Note"
                          source="sap_order_failed_message"
                        />
                      )}
                    </SimpleShowLayout>
                  </ShowView>
                );
              }}
            </ShowController>

            {/* <TextField source="business_site.ship_to_sap_number" label="Ship-To number" /> */}
            {/* <TextField source="order_total_price" label="Total Amount" />
                        <TextField source="order_total_tons" label="Total Tons" /> */}
            {/* {permissions === "isSap" && <TextField source="sales_org" />}
              {permissions === "isSap" && (
                <TextField source="distrib_channel" />
              )}
              {permissions === "isSap" && <TextField source="division" />}
              {permissions === "isSap" && <TextField source="comp_code_cd" />}
              {permissions === "isSap" && (
                <DateField label="Date 1st seen in LR" source="created_at" />
              )}
              {permissions === "isSap" &&
                props.resource !== "sap_digital_app_orders" &&
                getLocalStorageKey("show_all_orders") && (
                  <TextField label="Is App Order" source="is_app_order" />
                )}
              {permissions === "isSap" &&
                props.resource === "sap_digital_app_orders" && (
                  <BooleanField label="On Hold" source="on_hold" />
                )} */}
          </Tab>
          <Tab label="line Items">
            <ReferenceManyField
              label=""
              sort={{ field: "created_at", order: "DESC" }}
              reference="sap_digital_order_line_items"
              target="sap_digital_order_id"
              className="tab-pagination"
            >
              <List
                className="tab-list"
                // title="Line Items"
                // {...props}
                filterDefaultValues={{ sap_digital_order_id: businessIdVal }}
                sort={{ field: "created_at", order: "DESC" }}
                exporter={false}
                hasCreate={false}
                actions={false}
              >
                <Datagrid bulkActionButtons={false}>
                  {(showLineItemEdit &&
                    Number(orderStatus) < 3 &&
                    isSdoCreated === 0) ||
                    props.permissions === "isManual" ? (
                    <EditButton />
                  ) : showLineItemEdit ? (
                    <button
                      className="edit-modal-btn"
                      onClick={showModalForEdit}
                    >
                      Edit
                    </button>
                  ) : (
                    ""
                  )}
                  <TextField source="material_no" />
                  <TextField
                    source="product_master.name"
                    label="Product Name"
                  />
                  {/* {
                                    permissions === 'isSageAPI' ?
                                    <MaterialQtyUom label="Quantity" /> :
                                    <NumberField source="quantity" label="Quantity (Tons)" />
                                    
                                }
                                {
                                    permissions !== 'isSageAPI' &&
                                    <NumberField source="quantity_bags" label="Quantity (Bags)" />
                                }
                                {
                                    permissions === 'isSageAPI' ?
                                    <MaterialQtyUom label="Dispatched Quantity" /> :
                                    <NumberField source="dispatched_quantity" label="Dispatched Quantity (Tons)" />
                                }
                                {
                                    permissions !== 'isSageAPI' &&
                                    <NumberField source="dispatched_quantity_bags" label="Dispatched Quantity (Bags)" />
                                } */}
                  <NumberField source="quantity" />
                  {localStorageLocale === 'en-AE' && (
                    <TextField
                      source="truck_details.truck_number"
                      label="Truck"
                    />
                  )}
                  <TextField
                    source="product_master.input_uom_name"
                    label="UOM"
                  />
                  <ConvQtyField source="quantity" label="Quantity Conversion" />
                  <ConvQtyUomField
                    source="conversion_uom_name"
                    label="Quantity Conversion UOM"
                  />
                  <NumberField
                    source="dispatched_quantity"
                    label="Dispatched Quantity"
                  />
                  <TextField
                    source="product_master.input_uom_name"
                    label="Dispatched Quantity UOM"
                  />
                  <ConvQtyField
                    source="dispatched_quantity"
                    label="Dispatched Quantity Conversion"
                  />
                  <ConvQtyUomField
                    source="product_master.input_uom_name"
                    label="Dispatched Quantity Conversion UOM"
                  />
                  <AmountField source="unit_price" label="Unit Price" />
                  <LineItemTotalField label="Total" />
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
          <Tab label="Single Delivery">
            {permissions === "isManual" && <CreateSDOButton />}
            <ReferenceManyField
              label=""
              sort={{ field: "creation_date", order: "ASC" }}
              reference="sap_sdo_for_orders"
              target="sap_digital_order_id"
              className="tab-pagination"
            >
              <List
                className="tab-list"
                // {...props}
                filterDefaultValues={{ sap_digital_order_id: businessIdVal }}
                sort={{ field: "created_at", order: "DESC" }}
                // bulkActionButtons={false}
                exporter={false}
                hasCreate={false}
                actions={false}
              >
                <Datagrid permissions={permissions} bulkActionButtons={false}>
                  {permissions === "isManual" && <EditBtnField />}
                  {/* <EditButton basePath={resource} label="Edit" /> */}

                  {permissions === "isManual" && <TextField source="edit" />}
                  <TextField label="Delivery Number" source="logon_order_no" />
                  {/* <TextField label="Sales Order Number" source="logon_order_no" sortable={false} /> */}
                  {sdoFieldSettings &&
                    sdoFieldSettings.shipment_number &&
                    sdoFieldSettings.shipment_number.enabled && (
                      <TextField
                        // label="Shipment Number"
                        source="shipment_number"
                        sortable={false}
                      />
                    )}
                  {sdoFieldSettings &&
                    sdoFieldSettings.load_number &&
                    sdoFieldSettings.load_number.enabled && (
                      <TextField
                        // label="Loading Number"
                        source="load_number"
                        sortable={false}
                      />
                    )}
                  {/* {permissions === "isSap" && (
                      <TextField
                        label="Load Number"
                        source="logon_order_no"
                        sortable={false}
                      />
                    )} */}
                  <TextField
                    // label="Status"
                    source="order_status_description"
                    sortable={false}
                  />
                  <LoadingDateField
                    showTime={true}
                    // label="Loading date"
                    source="loading_date"
                    sortable={false}
                  />
                  <TruckPlateField source="truck_plate_no" sortable={false} />
                  <LsdOrderNoField
                    // label="Delivery Note"
                    source="lsd_order_no"
                    sortable={false}
                  />
                  {/* {permissions === "isSap" && (
                      <TextField
                        label="On Hold"
                        source="on_hold"
                        sortable={false}
                      />
                    )}
                    {permissions === "isSap" && (
                      <TextField
                        source="order_validation_code"
                        sortable={false}
                      />
                    )}
                    {permissions === "isSap" && (
                      <TextField
                        label="POD Code"
                        source="pod_code"
                        sortable={false}
                      />
                    )} */}
                  <ReceiveFullOrderField
                    // label="Received"
                    source="receive_full_order"
                    sortable={false}
                  />
                  <ReceivedDateField
                    source="received_date"
                    sortable={false}
                    showTime={true}
                  />
                  <DateField
                    // label="Disputed Time"
                    source="created_at"
                    sortable={false}
                    showTime={true}
                  />
                  <SdoOrderMaterialsLink />
                  <SdoDisputeDetailsLink />
                  {/* <ShowButton /> */}
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
          {/* <Tab label="Chatx"> */}
          {/* <div className="chat-page">
              <div className="cp-left-content">
                <InfiniteScroll
                  className="msg-list"
                  dataLength={
                    messageList.length + Math.floor(Math.random() * 18) + 1
                  }
                  next={fetchMsgList}
                  style={{ display: "flex", flexDirection: "column-reverse" }}
                  loader={<div>Loading ...</div>}
                  endMessage={<span />}
                  refreshFunction={fetchMsgList}
                  pullDownToRefresh={true}
                  pullDownToRefreshContent={
                    <div style={{ textAlign: "center" }}>...</div>
                  }
                  releaseToRefreshContent={
                    <div style={{ textAlign: "center" }}>..</div>
                  }
                >
                  {
                    messageList.length>0 && messageList.map((msg)=>{
                      return msg.message_created_from == "admin-web-app" ? (
                        <div className="admin-msg">
                          <img className="msg-acc-img" src="" />
                          <div className="msg-right-content">
                            <div className="row-item-sb">
                              <p className="msg-name-email">
                                {msg?.user?.name}
                              </p>
                              <p className="msg-date-time">
                                {moment(msg?.createdAt).format("DD/MM/YYYY, HH:mm:ss")}
                              </p>
                            </div>
                            <div>{msg?.text}</div>
                          </div>
                        </div>
                      ) : (
                        <div className="customer-msg">
                          <img className="msg-acc-img" src="" />
                          <div className="msg-right-content">
                            <div className="row-item-sb">
                              <p className="msg-name-email">
                                {msg?.user?.name}
                              </p>
                              <p className="msg-date-time">
                                {moment(msg?.createdAt).format("DD/MM/YYYY, HH:mm:ss")}
                              </p>
                            </div>
                            <div>{msg?.text}</div>
                          </div>
                        </div>
                      );
                    })}
                </InfiniteScroll>
                <div className="me-msg">
                  <img className="msg-acc-img" src="" />
                  <div className="flex-one">
                    <p className="msg-name-email"></p>
                    <textarea
                      className="type-msg-textarea"
                      type="text"
                      placeholder="Message"
                      value={message}
                      onChange={changeMessage}
                    />
                    <div>
                      <button
                        onClick={(e) => sendNewMessage(e)}
                        className="msg-submit-btn"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div> */}
          {/* <div className="cp-right-content">
                <p className="cprc-label">Status</p>
                <div className="chat-status">
                  <p className="chat-status-value">Closed</p>
                </div>
                <p className="cprc-label">Updated at</p>
                <p className="cprc-value">5/13/2024, 2:14:39 PM</p>
                <p className="cprc-label">Customer</p>
                <p className="cprc-value">Dante Luettgen</p>
                <p className="cprc-label">Product</p>
                <p className="cprc-value">Oriental Concrete Bacon</p>
                <p className="cprc-label">Activity</p>
                <p className="cprc-value">Jacklyn Green</p>
              </div> */}
          {/* </div> */}
          {/* </Tab> */}
          {
            isChatEnabled &&
            <Tab label={chatLabel}>
              <div className="chat-page chat-page-rh">
                <div className="cp-left-content"
                // ref={scrollableRef}
                >
                  {messageList.length > 0 && !isLastEvaluatedKeyPresent && (
                    <div className="no-msgs-txt">No more previous messages</div>
                  )}
                  <SimpleInfiniteScroller
                    canScrollUp={isLastEvaluatedKeyPresent}
                    loadMore={() => fetchMsgList(true, data)}
                    // loadMore={loadMoreFetchMsgList}
                    canScrollDown={false}
                    reverse
                  >
                    <ul className="chat-list">
                      {messageList.length > 0 ? (
                        messageList.map((msg) => {
                          // console.log("single msg ---->>>>>", msg);
                          return (
                            <div key={msg.message_id}>
                              {msg.user_id == id ? (
                                <div className="admin-msg">
                                  <div className="parti-initial">
                                    <div className="parti-initial-value">{getInitials(msg?.user?.name)}</div>
                                  </div>
                                  <div className="msg-right-content">
                                    <div className="row-item-sb">
                                      <p className="msg-name-email">
                                        {msg?.user?.name}
                                      </p>
                                      <p className="msg-date-time">
                                        {moment(msg?.createdAt).format(
                                          "DD/MM/YYYY, HH:mm:ss"
                                        )}
                                      </p>
                                    </div>
                                    <div className="row-space-between">
                                      <p>{msg?.text}</p>
                                      <ThreeDotIcon
                                        className="pointer-cursor"
                                        onClick={() => openReadInfo(msg)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="customer-msg">
                                  <div className="parti-initial">
                                    <div className="parti-initial-value">{getInitials(msg?.user?.name)}</div>
                                  </div>
                                  <div className="msg-right-content">
                                    <div className="row-item-sb">
                                      <p className="msg-name-email">
                                        {msg?.user?.name}
                                      </p>
                                      <p className="msg-date-time">
                                        {moment(msg?.createdAt).format(
                                          "DD/MM/YYYY, HH:mm:ss"
                                        )}
                                      </p>
                                    </div>
                                    <div>{msg?.text}</div>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <div className="wc-to-chat">Welcome to chat</div>
                      )}
                    </ul>
                  </SimpleInfiniteScroller>
                  <div className="me-msg">
                    <div className="row-align-top flex-one">
                      <div className="parti-initial">
                        <div className="parti-initial-value">{getInitials(userName)}</div>
                      </div>
                      <div className="flex-one">
                        <p className="msg-name-email">{userName}</p>
                        <textarea
                          className="type-msg-textarea"
                          type="text"
                          placeholder="Message"
                          value={message}
                          onChange={changeMessage}
                        />
                        <div>
                          <button
                            onClick={(e) => sendNewMessage(e)}
                            disabled={message.length <= 0 || message.trim() === ''}
                            className="msg-submit-btn"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {showReadModal && (
                  <div className="cp-right-content">
                    <button className="close-msg-info" onClick={() => setShowReadModal(false)}><CloseIcon /></button>
                    <div className="msg-info-row">
                      <div className={readUnReadTabValue == 1 ? "msg-info-item-active" : "msg-info-item"} onClick={() => toggleReadUnReadFunction(1)} >Read by</div>
                      <div className={readUnReadTabValue == 2 ? "msg-info-item-active" : "msg-info-item"} onClick={() => toggleReadUnReadFunction(2)}>Delivered to</div>
                    </div>
                    {readUnReadTabValue == 1 ?
                      readParticipants.length ?
                        readParticipants.map((readParticipant) => {
                          return (
                            <div className="row-align-center parti-row">
                              <div className="parti-initial">
                                <div className="parti-initial-value">{getInitials(readParticipant?.name)}</div>
                              </div>
                              <div className="parti-name">{readParticipant?.name}</div>
                            </div>
                          );
                        }) :
                        <div>No read participants</div>
                      : null
                    }

                    {
                      readUnReadTabValue == 2 ?
                        unreadParticipants ?
                          unreadParticipants.map((unreadParticipant) => {
                            return (
                              <div className="row-align-center parti-row">
                                <div className="parti-initial">
                                  <div className="parti-initial-value">{getInitials(unreadParticipant?.name)}</div>
                                </div>
                                <div className="parti-name">{unreadParticipant?.name}</div>
                              </div>
                            );
                          }) :
                          <div>No unread participants</div>
                        : null
                    }
                  </div>
                )}
                {
                  !showReadModal &&
                  <div className="cp-right-content">
                    <div className="cprc-label">Status</div>
                    <div className="chat-status" style={currentStyle}>
                      <div className="chat-status-value">{currentChatStatus}</div>
                    </div>
                    <div>
                      <div className="parti-heading">Participants</div>
                      {participantList &&
                        participantList.map((participants) => {
                          return (
                            <div className="row-align-center parti-row">
                              <div className="parti-initial">
                                <div className="parti-initial-value">{getInitials(participants?.name)}</div>
                              </div>
                              <div className="parti-name">{participants?.name}</div>
                            </div>
                          );
                        })}
                    </div>
                  </div>

                }
              </div>
            </Tab>
          }
        </TabbedShowLayout>
      </Show>
      {openMessageModal && (
        <CustomModal
          open={openMessageModal}
          onCloseModal={onCloseMessageModal}
          showCancel={false}
          text="Yo can not edit line items untill you delete all single deliveries."
          onOkModal={onOkMessageModal}
        />
      )}
    </div>
  );
};

export default React.memo(DigitalOrdersShow);
